module.exports = __webpack_public_path__ + "static/media/school_ice_may25.c13bd244.csv";